export default "__VITE_PUBLIC_ASSET__377cde98__"